import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import React from 'react';

import { EmailSummaryDto } from '@/api/generated';
import { themeColors } from '@/config/theme/themeColors.ts';
import { EmailAttachment } from '@/views/emails/components/attachmentItem/EmailAttachment.comp.tsx';
import { useGetAttachment } from '@/views/emails/components/threadEmails/components/attachments/util/useGetAttachment.util.ts';

interface Props {
  attachments: EmailSummaryDto['attachments'];
  emailId: string;
}

export const ThreadEmailsItemAttachments: React.FC<Props> = props => {
  const { attachments, emailId } = props;
  const { getAttachment, isGettingAttachment } = useGetAttachment();

  if (attachments.length === 0) {
    return null;
  }

  const handleDownload = (externalAttachmentId: string) => async () => {
    await getAttachment({
      emailId,
      externalAttachmentId,
    });
  };

  return (
    <>
      <Divider />
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
        {attachments.map(attachment => (
          <EmailAttachment
            isReady={!isGettingAttachment}
            key={attachment.attachmentId}
            name={attachment.name}
          >
            <Box
              onClick={handleDownload(attachment.externalAttachmentId)}
              sx={{ alignItems: 'center', display: 'flex', py: 0.5 }}
            >
              <DownloadOutlinedIcon sx={{ color: themeColors.accentColor }} />
            </Box>
          </EmailAttachment>
        ))}
      </Stack>
    </>
  );
};
